import React from 'react';

function NewVision() {
    return (
        <div className="NewVision_Container__lfemW">
            <div className="NewVision_headingCont__TN1qI">
                <h2 className="NewVision_heading__XlTVr">OUR VISION</h2>
                <div className="NewVision_underline__VxrFq"></div>
            </div>
            <p className="NewVision_subHead__3qv_x">AI for Social Good</p>
            <p className="NewVision_para__xm_Pw">Explainable AI (XAI) is an emerging subject of machine learning research that
                refers to strategies that try to provide transparency to typically opaque AI models and their predictions.
            </p>
            <div className="NewVision_qualification__sections__qWk8Y">
                <div>
                    <div className="NewVision_qualification__data__s3l3X">
                        <div>
                            <h3 className="NewVision_qualification__title__HUzhX">Diversity &amp; Fairness</h3>
                            <span className="NewVision_qualification__subtitle__EQ6HD">When training our AI models, we consider
                                ethical and social implications of algorithm-based decision making. Our solutions use
                                high-quality and fairly-represented data sets to eliminate human cognitive biases.</span>
                        </div>
                        <div>
                            <span className="NewVision_qualification__rounder__zWnvF">
                                <span></span>
                            </span>
                            <span className="NewVision_qualification__line__aQioP"></span>
                        </div>
                    </div>
                    <div className="NewVision_qualification__data__s3l3X">
                        <div></div>
                        <div>
                            <span className="NewVision_qualification__rounder__zWnvF">
                                <span></span>
                            </span>
                            <span className="NewVision_qualification__line__aQioP"></span>
                        </div>
                        <div>
                            <h3 className="NewVision_qualification__title__HUzhX">Regulatory Compliance</h3>
                            <span className="NewVision_qualification__subtitle__EQ6HD">Working with clients globally, LENS
                                acknowledges applicable data privacy regulations, such as the GDPR, HIPAA, and others, in all
                                our solutions handling sensitive data. We also ensure our algorithms allow for the required
                                level of decision-making transparency and explainability.</span>
                        </div>
                    </div>
                    <div className="NewVision_qualification__data__s3l3X">
                        <div>
                            <h3 className="NewVision_qualification__title__HUzhX">Code of Ethics</h3>
                            <span className="NewVision_qualification__subtitle__EQ6HD">LENS believes in a just, non-violent
                                world of equality and fairness. We prize democratic values, civil liberties, and open and
                                informed debate. When used to further these values, algorithm-based decision-making models
                                can continue to make the world a safer, better place for everyone.</span>
                        </div>
                        <div>
                            <span className="NewVision_qualification__rounder__zWnvF">
                                <span></span>
                            </span>
                            <span className="NewVision_qualification__line__aQioP"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewVision;